import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ab36a6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" InfraPilot"),
          _hoisted_3,
          _createTextVNode(" 星汉未来AI托管平台 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString('依托多项专利技术，无需改造即可实现AI应用与大模型推理的Serverless化。' +
          'InfraPilot支持分钟级应用部署、GPU/CPU自动调度、无人化运维以及自动化成本治理。' +
          '一站式管理企业内各类自研AI应用与大模型，构建高效的AI应用开发及大模型训练推理平台，显著提升研发效率。'))
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" <a-space :size=\"$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'\"> "),
      _createCommentVNode(" <a-button type=\"link\" class=\"button_n_1\"\n                  @click=\"clickToCloud()\">\n          立即注册体验\n        </a-button> "),
      _createCommentVNode("<a-button type=\"link\" class=\"button_n_1\""),
      _createCommentVNode("          @click=\"localTo($Config.Href.github)\">"),
      _createCommentVNode("  体验开源版"),
      _createCommentVNode("</a-button>"),
      _createCommentVNode("<a-button type=\"link\" class=\"button_n_3\""),
      _createCommentVNode("          @click=\"$Store.Page().openModal('modalFormCollection', 'deployment')\">"),
      _createCommentVNode("  预约私有化部署"),
      _createCommentVNode("</a-button>"),
      _createCommentVNode(" </a-space> ")
    ])
  ]))
}